export default "__VITE_ASSET__ad4634d8__"